export default __webpack_public_path__ + "static/media/829.b436e46d.gif";